var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrowIcon = function SvgBackArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.75 13.5a6.006 6.006 0 01-6 6H7.5a.75.75 0 110-1.5h8.25a4.5 4.5 0 100-9H4.81l3.22 3.22a.75.75 0 11-1.061 1.06l-4.5-4.5a.75.75 0 010-1.06l4.5-4.5A.75.75 0 118.03 4.28L4.81 7.5h10.94a6.006 6.006 0 016 6z"
  })));
};
export default SvgBackArrowIcon;